import React from 'react'
import styled from '@emotion/styled'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { LoadingPlaceholder } from '@mobi/component-library/Misc/LoadingPlaceholder'
import { colors, radius, spacing } from '@mobi/component-library/Foundations'
import { HeaderSkeleton } from './HeaderSkeleton'

const enum LocalConstants {
  BetDetailsWrapperClass = 'bet_details_wrapper',
  BetDetailsContentClass = 'bet_details_content',
}

export const SharedBetCardSkeleton = () => (
  <CardWrapperStyled>
    <HeaderSkeleton />
    <div className={LocalConstants.BetDetailsWrapperClass}>
      <Flex justifyContent='space-between'>
        <LoadingPlaceholder width={spacing.huge} height={spacing.md} borderRadius={radius.lg} />
        <LoadingPlaceholder width={spacing.lgx1} height={spacing.md} borderRadius={radius.lg} />
      </Flex>

      <div className={LocalConstants.BetDetailsContentClass}>
        <Flex justifyContent='space-between'>
          <Flex gap={spacing.smx2}>
            <LoadingPlaceholder width={spacing.lg} height={spacing.lg} borderRadius={radius.lg} />

            <Flex justifyContent='space-between'>
              <Flex flexDirection='column' gap={spacing.smx1}>
                <LoadingPlaceholder
                  width={spacing.lgx1}
                  height={spacing.md}
                  borderRadius={radius.lg}
                />
                <LoadingPlaceholder
                  width={spacing.huge}
                  height={spacing.md}
                  borderRadius={radius.lg}
                />
              </Flex>
            </Flex>
          </Flex>

          <LoadingPlaceholder width={spacing.lg} height={spacing.md} borderRadius={radius.lg} />
        </Flex>
      </div>
    </div>

    <LoadingPlaceholder width='100%' height={spacing.lg} borderRadius={radius.lg} />
  </CardWrapperStyled>
)

// Styles
const CardWrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx1,
  backgroundColor: colors.white,
  padding: spacing.sm,
  borderRadius: radius.lgx1,

  ['.' + LocalConstants.BetDetailsContentClass]: {
    marginTop: '1rem',
    background: colors.surface[200],
    padding: spacing.sm,
    borderRadius: radius.lgx1,
  },

  ['.' + LocalConstants.BetDetailsWrapperClass]: {
    background: colors.neutral[200],
    padding: spacing.sm,
    borderRadius: radius.lgx1,
  },
})
